import {
  Autocomplete,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { useEffect } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../../components/services/api";
import AddIcon from "@mui/icons-material/Add";
import { useParams } from "react-router";
export default function LogStatus() {
  const { id } = useParams()
  const [log_data, setLogData] = useState([]);
  const [value, setValue] = useState("");
  const [option, setOption] = useState([]);
  const [co, setCo] = useState([]);
  const UserEmpId = localStorage.getItem("EmpId");
  const columnsLog = [
    // {
    //   field: "Status",
    //   headerName: "STATUS",
    //   width: 150,
    //   valueFormatter: ({ value }) => (value == 1 ? "INSTOCK" : "OUTSTOCK"),
    // },
    { field: "TypeName", headerName: "Type", width: 150 },
    { field: "EmployeeName", headerName: "Employee Name", width: 180 },

    { field: "Action", headerName: "Action", width: 200 },
    { field: "Remark", headerName: "Remark", width: 200 },
    {
      field: "CreateDate",
      headerName: "Date Time",
      width: 200,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-yyyy HH:mm");
      },
    },
  ];

  const getLempo = async () => {
    try {
      const data = await api.get("api/employee/list");
      setOption(data?.data.filter((e) => e?.Status == 1));

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };const getLogStatus = async () => {
    try {
      const data = await api.get(`api/saleorder/detail/logstatus/${id}`);
      setLogData(data.data.LogStatus);
      setCo(data?.data.CoOWner);

      //   setLog_data_length(3);
    } catch (e) {
      console.log(e);
    }
  };

  const deletestaff = async (i) => {
    
    const data = {
      SaleOrderId: id,
      EmpId: i?.EmpId,
      CoOwnerId: i?.CoOwnerId,    };
    const result = await api.post("api/saleorder/update/coowner/delete", data);
    if (result.data === true) {
      const MySwal = withReactContent(Swal);

      MySwal.fire({
        icon: "success",
        didOpen: () => {
          MySwal.clickConfirm();
        },
      }).then(() => {
        return MySwal.fire("สำเร็จ!", "ลบรายชื่อสำเร็จ !", "success").then(
          (result) => {
            if (result.isConfirmed) {
              getLogStatus();
            }
          }
        );
      });
    }
  };

  const handleadd = async () => {
    const data = {
      SaleOrderId: id,
      EmpId: value?.EmpId,
      CoOwnerId: null,
    };
    const result = await api.post("api/saleorder/update/coowner/add", data);
    if (result.meta.status === true) {
      const MySwal = withReactContent(Swal);

      MySwal.fire({
        icon: "success",
        didOpen: () => {
          MySwal.clickConfirm();
        },
      }).then(() => {
        return MySwal.fire("สำเร็จ!", "เพิ่มรายชื่อสำเร็จ !", "success").then(
          (result) => {
            if (result.isConfirmed) {
              getLogStatus();
              setValue("");
            }
          }
        );
      });
    }
  };

  
  // const getCooner = async () => {
  //   const SoId = {
  //     SoId: log_data[0]?.SoId,
  //   };
  //   try {
  //     const data = await api.post("api/saleorder/co-owner/list", SoId);
  //     setCo(data?.data);
  //     console.log(data);
  //     //   setLog_data_length(3);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // useEffect(() => {
  //   getCooner();
  // }, [log_data]);

  useEffect(() => {
    getLogStatus();
    getLempo();
  }, []);
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          marginTop: "10px",
          paddingBottom: "24px",
        }}
      >
        <Box>
          {" "}
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "500",
              color: "blue",
              marginBottom: "10px",
            }}
          >
            Staff
          </Typography>
        </Box>

        <Autocomplete
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          sx={{ width: 300 }}
          options={option}
          getOptionLabel={(option) => {
            return (option?.EmpNo || "") + '-' +
              (option?.EmpName || "") +
              " - " +
              (option?.EmpLastName || "")

          }}
          renderInput={(params) => (
            <TextField color="success" {...params} label="Employee Name" />
          )}
        />
        <Button
          type="button"
          variant="contained"
          style={{
            background: "#80c340",
            borderColor: "#80c340",
            marginTop: "10px",
          }}
          onClick={handleadd}
        >
          <AddIcon /> Add
        </Button>
        {co?.length > 0 ? (
          <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
            <Table stickyHeader>
              <TableRow>
                <TableCell align="center">#</TableCell>
                <TableCell align="center">Employee No</TableCell>
                <TableCell align="center">Employee Name</TableCell>
                <TableCell align="center">Company</TableCell>
                <TableCell align="center">Branch</TableCell>

                <TableCell align="center">Department</TableCell>
                <TableCell align="center">Role</TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
              {co?.map((data, index) => {
                return (
                  <TableBody>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center" width="25%">
                      {data?.Employee?.EmpNo || ""}
                    </TableCell>
                    <TableCell align="center">
                      {data?.Employee?.firstname} {data?.Employee?.lastname}
                    </TableCell>
                    <TableCell align="center">
                      {data?.Employee?.Company?.CompanyName || ""}
                    </TableCell>
                    <TableCell align="center">
                      {data?.Employee?.Branch?.BranchName || ""}
                    </TableCell>

                    <TableCell align="center">
                      {data?.Employee?.Department?.DepartmentName || ""}
                    </TableCell>

                    <TableCell align="center">{data?.Employee?.role?.roleName || ""}</TableCell>

                    <TableCell align="right">
                      <Button
                        onClick={() => deletestaff(data)}
                        variant="outlined"
                        style={{
                          marginLeft: "15px",
                          borderColor: "#80c340",
                          color: "#80c340",
                        }}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
        ) : null}
      </Box>
      <Box
        sx={{
          height: 660,
          width: "100%",
          marginTop: "20px",
          paddingBottom: "24px",
          "& .Active": {
            color: "#28A745",
          },
          "& .Inactive": {
            color: "#F53C56",
          },
        }}
      >
        <Box>
          {" "}
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "500",
              color: "blue",
              marginBottom: "10px",
            }}
          >
            Status
          </Typography>
        </Box>
        <DataGrid
          getRowId={(r) => r.LogId}
          rows={log_data}
          columns={columnsLog}
          pageSize={10}
          rowsPerPageOptions={[10]}
          hideFooterSelectedRowCount
          disableColumnFilter
          disableColumnMenu
          getCellClassName={(params) => {
            if (params.field === "Status") {
              return params.value == 1 ? "Active" : "Inactive";
            }
          }}
        />
      </Box>
    </Box>
  );
}
